import { memo, useCallback, useState } from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useLocalization } from '../../../../Contexts/Localization';
import { GoMotoComponent } from '../../../../API/GoMoto.types';
import { GMIconButton } from '..';
import { GMModal, GMModalBody, GMModalHeader } from '../../../Dialog/Modal';
import { InfoIconProps } from './InfoIcon.types';

/** Opens the info text in a modal on click so it remains reachable on touch devices, which don't fire the hover tooltip. */
const InfoIcon: GoMotoComponent<InfoIconProps> = memo(({
    tooltip,
    color = 'primary',
    className,
    spanClassName,
}) => {
    const Localization = useLocalization();
    const [showInfoModal, setShowInfoModal] = useState(false);
    const openInfoModal = useCallback(() => setShowInfoModal(true), []);
    const closeInfoModal = useCallback(() => setShowInfoModal(false), []);

    return (
        <>
            <GMModal
                open={showInfoModal}
                position={'top'}
                onClose={closeInfoModal}
            >
                <GMModalHeader onClose={closeInfoModal}>
                    {Localization.Information}
                </GMModalHeader>
                <GMModalBody>
                    {tooltip}
                </GMModalBody>
            </GMModal>
            <GMIconButton
                color={color}
                tooltip={tooltip}
                className={className}
                spanClassName={spanClassName}
                notTabbable
                onClick={openInfoModal}
            >
                <InfoOutlinedIcon />
            </GMIconButton>
        </>
    );
});

export default InfoIcon;
